import axios from "axios"
import { API_ROOT_URL } from "../requests"

export const GET_USERS_PERMISSIONS = "get_users_permissions"

export const getUsersPermissions = async () => {
  const response = await axios.get(`${API_ROOT_URL}/admin/groups/`)
  return { type: GET_USERS_PERMISSIONS, payload: response.data }

}

export const setUserPermission = async (data) => {
  await axios.post(`${API_ROOT_URL}/admin/groups/`, data)
  return await getUsersPermissions()
}